export default {
  ENEMY: "ENEMY",
  MELEE_WEAPON: "MELEE_WEAPON",
  RANGED_WEAPON: "RANGED_WEAPON",
  SHIELD: "SHIELD",
  GRENADE: "GRENADE",
  POWER: "POWER",
  TRAP: "TRAP",
  LEVEL: "LEVEL",
};
